export default "__VITE_ASSET__BbrkIHQk__"